import { Action, createReducer, on } from '@ngrx/store';
import { PhoneValidationStatus } from '@shared/models/phone-number.interface';

import {
  ResetMfePhone,
  UpdateMfePhoneFromGetData,
  UpdateMfePhoneMobileFlag,
  UpdateMfePhoneNumber,
  UpdateMfePhoneValidationStatus,
} from '../../actions/personal-phone/personal-phone.actions';
import { StartOverStateCleared } from '../../actions/start-over/start-over.actions';

export interface MfePhoneState {
  phoneNumber: string;
  isMobile: boolean;
  validationStatus: PhoneValidationStatus;
}

export const initialMfePhoneState: MfePhoneState = {
  phoneNumber: '',
  isMobile: false,
  validationStatus: PhoneValidationStatus.INVALID,
};

const mfePhoneReducer = createReducer(
  initialMfePhoneState,
  on(
    UpdateMfePhoneFromGetData,
    (state, { payload }): MfePhoneState => ({
      ...state,
      phoneNumber: payload.phoneNumber,
      isMobile: payload.isMobile,
      validationStatus: payload.validationStatus,
    }),
  ),
  on(
    UpdateMfePhoneNumber,
    (state, { payload }): MfePhoneState => ({
      ...state,
      phoneNumber: payload,
    }),
  ),
  on(
    UpdateMfePhoneMobileFlag,
    (state, { payload }): MfePhoneState => ({
      ...state,
      isMobile: payload,
    }),
  ),
  on(
    UpdateMfePhoneValidationStatus,
    (state, { payload }): MfePhoneState => ({
      ...state,
      validationStatus: payload,
    }),
  ),
  on(ResetMfePhone, (): MfePhoneState => ({ ...initialMfePhoneState })),
  on(StartOverStateCleared, (): MfePhoneState => ({ ...initialMfePhoneState })),
);

export function reducer(state: MfePhoneState | undefined, action: Action) {
  return mfePhoneReducer(state, action);
}
